export type FilterKind = 'tipo' | 'vencido' | 'conteudo' | 'config';

export type FilterChip = {
	token: string;
	label: string;
	color: string;
	kind: FilterKind;
};

const BRAND = {
	navy: '#003a70',
	red: '#d7282f',
	iah: '#4f46e5',
	copyright: '#0f766e',
	loja: '#92400e',
	livro: '#2296ff',
	revista: '#ef0a41',
	video: '#8b36e8',
	informativo: '#df3d00',
	config: '#475569',
	unlimited: '#52c41a',
	expired: '#8c8c8c',
};

export const FILTER_CHIPS: FilterChip[] = [
	{ token: 'cap:venda', label: 'Cliente Venda', color: BRAND.navy, kind: 'tipo' },
	{ token: 'cap:assinatura', label: 'Fórum Assinaturas', color: BRAND.red, kind: 'tipo' },
	{ token: 'cap:forum-ia', label: 'Fórum IAH', color: BRAND.iah, kind: 'tipo' },
	{ token: 'cap:copyright', label: 'Direito Autoral', color: BRAND.copyright, kind: 'tipo' },
	{ token: 'cap:loja', label: 'Loja Digital', color: BRAND.loja, kind: 'tipo' },

	{ token: 'assinatura:expired', label: 'Assinatura vencida', color: BRAND.expired, kind: 'vencido' },
	{ token: 'venda:expired', label: 'Venda vencida', color: BRAND.expired, kind: 'vencido' },
	{ token: 'ia:expired', label: 'IAH vencida', color: BRAND.expired, kind: 'vencido' },
	{ token: 'contract:expired', label: 'Algum contrato vencido', color: BRAND.expired, kind: 'vencido' },

	{ token: 'cap:book-serie', label: 'Séries de livro', color: BRAND.livro, kind: 'conteudo' },
	{ token: 'cap:avulso', label: 'Livro avulso', color: BRAND.livro, kind: 'conteudo' },
	{ token: 'cap:revistas', label: 'Revistas', color: BRAND.revista, kind: 'conteudo' },
	{ token: 'cap:video-serie', label: 'Séries de vídeo', color: BRAND.video, kind: 'conteudo' },
	{ token: 'cap:informativos', label: 'Informativos', color: BRAND.informativo, kind: 'conteudo' },

	{ token: 'client:unlimited', label: 'Ilimitado', color: BRAND.unlimited, kind: 'config' },
	{ token: 'cap:sso', label: 'Config SSO', color: BRAND.config, kind: 'config' },
	{ token: 'cap:domain', label: 'Config domínio', color: BRAND.config, kind: 'config' },
];

export const CHIPS_TIPO = FILTER_CHIPS.filter((c) => c.kind === 'tipo');
export const CHIPS_VENCIDO = FILTER_CHIPS.filter((c) => c.kind === 'vencido');
export const CHIPS_SECUNDARIO = FILTER_CHIPS.filter(
	(c) => c.kind === 'conteudo' || c.kind === 'config'
);

export type CapabilityBadge = {
	label: string;
	color: string;
	expiry_field?: 'venda_end_at' | 'assinatura_end_at' | 'forum_ia_end_at';
};

const BADGES: Record<string, CapabilityBadge> = {
	'cap:venda': { label: 'Venda', color: BRAND.navy, expiry_field: 'venda_end_at' },
	'cap:assinatura': { label: 'Assinaturas', color: BRAND.red, expiry_field: 'assinatura_end_at' },
	'cap:forum-ia': { label: 'Fórum IAH', color: BRAND.iah, expiry_field: 'forum_ia_end_at' },
	'cap:copyright': { label: 'Direito Autoral', color: BRAND.copyright },
	'cap:loja': { label: 'Loja Digital', color: BRAND.loja },
	'cap:book-serie': { label: 'Séries de livro', color: BRAND.livro },
	'cap:avulso': { label: 'Livro avulso', color: BRAND.livro },
	'cap:revistas': { label: 'Revistas', color: BRAND.revista },
	'cap:video-serie': { label: 'Séries de vídeo', color: BRAND.video },
	'cap:informativos': { label: 'Informativos', color: BRAND.informativo },
};

const BADGE_ORDER = Object.keys(BADGES);

export function contract_badges(capabilities: string[]): [string, CapabilityBadge][] {
	return BADGE_ORDER.filter((key) => capabilities.includes(key)).map((key) => [key, BADGES[key]]);
}
